module.exports = __webpack_public_path__ + "static/assets/c2c7e5f3ce7d4f9795d200e5b5908eea.png";